<template>
  <el-table
      :data="terminals">
    <el-table-column
        prop="id"
        label="サイトID"
        width="120">
    </el-table-column>

    <el-table-column
        prop="name"
        label="サイト名">
    </el-table-column>

    <el-table-column
        prop="description"
        label="説明">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="row.description"
              placeholder="未設定"
              multi-line>
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        prop="communicationProtocol"
        label="通信方法"
        width="100"
        align="center">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="communicationProtocols[row.communicationProtocol]"
              placeholder="未接続"
              align="center">
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        prop="status"
        label="ステータス"
        width="100">
      <template #default="{row}">
        <table-inline>
          <text-field-like
              :value="controllerStatuses[row.status]"
              placeholder="未接続"
              align="center">
          </text-field-like>
        </table-inline>
      </template>
    </el-table-column>

    <el-table-column
        prop="pollingRate"
        label="ポーリング周期(秒)"
        width="100">
      <template #default="{row}">
        {{ row.communicationProtocol === 'amqp' ? '即時' : row.pollingRate }}
      </template>
    </el-table-column>

    <el-table-column
      prop="createdAt"
      label="登録日"
      width="100">
      <template #default="{row}">
        {{ formatDate(row.createdAt) }}
      </template>
    </el-table-column>

    <el-table-column
      prop="publishing"
      label="公開"
      width="50"
      align="center">
      <template #default="{row}">
        <readonly-checkbox :value="row.publishing"></readonly-checkbox>
      </template>
    </el-table-column>

    <el-table-column
      width="130"
      align="right"
      fixed="right">
      <template #default="{row}">
        <icon-btns>
          <icon-btn
              type="delete"
              @click="openDeleteDialog(row)"
              :disabled="terminals.length === 1">
          </icon-btn>
          <icon-btn
              type="edit-content"
              @click="openUpdateDialog(row)">
          </icon-btn>
          <icon-btn
              tooltip="認証ファイルダウンロード"
              icon="mdi-key-variant"
              @click="openCredentialDownloadDialog(row)">
          </icon-btn>
        </icon-btns>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Formatter from "@/utils/Formatter";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import IconBtns from "@/components/molecules/IconBtns";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {CONTROLLER_STATUSES, TERMINAL_COMMUNICATION_PROTOCOLS} from "@/constants";

export default {
  name: 'TerminalTable',
  components: {TextFieldLike, TableInline, IconBtn, IconBtns, ReadonlyCheckbox},
  mixins: [
    Formatter
  ],
  props: {
    terminals: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      communicationProtocols: TERMINAL_COMMUNICATION_PROTOCOLS,
      controllerStatuses: CONTROLLER_STATUSES,
    }
  },
  methods: {
    openDeleteDialog(row) {
      this.$emit('openDeleteDialog', row)
    },
    openUpdateDialog(row) {
      this.$emit('openUpdateDialog', row)
    },
    openCredentialDownloadDialog(row) {
      this.$emit('openCredentialDownloadDialog', row)
    }
  }
}
</script>
